import React from "react";
import { useTranslation } from "react-i18next";
import convertHtmlToReact from "@hedgedoc/html-to-react";

const PromotionalConsentCheckbox = () => {
    const { t } = useTranslation(["translation"]); 
    return <div className="offers-and-promotions check-box-wrapper">
                <input type="checkbox" id="brother-plus-offers-promotions" />
                <label htmlFor="brother-plus-offers-promotions">{convertHtmlToReact(t('BROTHER_PLUS.EASY_PAY_BANNER.PERSONALIZED_OFFERS_LABEL'))}</label>
            </div>
}

export default PromotionalConsentCheckbox